import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import CustomerHome from "./pages/CustomerHome";
import Offers from "./pages/Offers";
import AccountAuth from "./pages/AccountAuth";
import Register from "./pages/Register";
import { InstallAppPrompt } from "./components/InstallAppPrompt";
import { GlobalHomeLogo } from "./components/GlobalHomeLogo";
import Account from "./pages/Account";
import Wallet from "./pages/Wallet";
import { AdminFab } from "./components/AdminFab";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import { Home, Prezzi, Funzionalita, ComeFunziona, Demo, Affiliati, Faq, Contatti, Legal, SiteAdmin } from "./pages/MarketingSite";
import VideoExplainer from "./pages/VideoExplainer";
import Login from "./pages/Login";
import Storefront from "./pages/Storefront";
import Checkout from "./pages/Checkout";
import PayPage from "./pages/PayPage";
import OrderTracking from "./pages/OrderTracking";
import AdminConsole from "./pages/AdminConsole";
import Backoffice from "./pages/Backoffice";
import OperatorDashboard from "./pages/OperatorDashboard";
import { Loader2 } from "lucide-react";

function Protected({ roles, children, redirectTo = "/login" }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin brand-text" /></div>;
  if (!user) return <Navigate to={redirectTo} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={redirectTo} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<CustomerHome mode="home" />} />
            <Route path="/esplora" element={<CustomerHome mode="search" />} />
            <Route path="/offerte" element={<Offers />} />
            <Route path="/diventa-partner" element={<Home />} />
            <Route path="/funzionalita" element={<Funzionalita />} />
            <Route path="/prezzi" element={<Prezzi />} />
            <Route path="/come-funziona" element={<ComeFunziona />} />
            <Route path="/video" element={<VideoExplainer />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/affiliati" element={<Affiliati />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy-policy" element={<Legal />} />
            <Route path="/cookie-policy" element={<Legal />} />
            <Route path="/termini-e-condizioni" element={<Legal />} />
            <Route path="/site-admin" element={<Protected roles={["super_admin"]}><SiteAdmin /></Protected>} />
            <Route path="/vetrina" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/esercenti/login" element={<Login />} />
            <Route path="/account/login" element={<AccountAuth />} />
            <Route path="/registrati" element={<Register />} />
            <Route path="/recupera-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verifica-email" element={<VerifyEmail />} />
            <Route path="/account" element={<Protected roles={["customer"]} redirectTo="/account/login"><Account /></Protected>} />
            <Route path="/account/coupon" element={<Protected roles={["customer"]} redirectTo="/account/login"><Wallet /></Protected>} />
            <Route path="/t/:slug" element={<Storefront />} />
            <Route path="/locale/:slug" element={<Storefront />} />
            <Route path="/locale/:slug/:storeSlug" element={<Storefront />} />
            <Route path="/t/:slug/checkout" element={<Checkout />} />
            <Route path="/t/:slug/:storeSlug" element={<Storefront />} />
            <Route path="/t/:slug/:storeSlug/checkout" element={<Checkout />} />
            <Route path="/pay/:token" element={<PayPage />} />
            <Route path="/order/:token" element={<OrderTracking />} />
            <Route path="/admin" element={<Protected roles={["super_admin"]}><AdminConsole /></Protected>} />
            <Route path="/manage" element={<Protected roles={["tenant_admin", "store_manager"]}><Backoffice /></Protected>} />
            <Route path="/dashboard" element={<Protected roles={["tenant_admin", "store_manager", "operator", "driver"]}><OperatorDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallAppPrompt />
          <GlobalHomeLogo />
          <AdminFab />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
